<div
  class="border border-gray-200 rounded-lg p-4 mb-3 flex items-center justify-between"
>
  <div class="flex items-center">
    <div class="text-green-500 mr-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"
        />
      </svg>
    </div>
    <div class="font-medium">Efectivo</div>
  </div>
  <div class="h-5 w-5 rounded-full border border-gray-300 flex items-center justify-center">
    @if (isPayWithCashSignal()) {
      <div class="h-3 w-3 bg-green-500 rounded-full"></div>
    }
  </div>
</div>
